
import { lazy, Suspense } from 'react';
import Hero from './components/Hero';
import Navbar from './components/Navbar';

const Waitlist = lazy(() => import('./components/Waitlist'));
const Features = lazy(() => import('./components/Features'));
const HowItWorks = lazy(() => import('./components/HowItWorks'));
const Benefits = lazy(() => import('./components/Benefits'));
const Footer = lazy(() => import('./components/Footer'));

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <Hero />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <Waitlist />
      </Suspense>
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <Features />
      </Suspense>
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <HowItWorks />
      </Suspense>
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <Benefits />
      </Suspense>
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <Footer />
      </Suspense>
    </div>
  );
}
